// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */
.company_info_TriNA {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.h4_RPaAb {
  margin-top: 5px;
  margin-bottom: 15px;
  font-size: 18px;
  color: #165ca9;
}
.small_xuLpa {
  display: block;
  font-size: 12px;
  color: gray;
}
.barcode_vdXHI {
  margin-left: auto;
  width: 150px;
  height: 80px;
  object-fit: contain;
}
.h3_span_YBqm4 {
  font-size: 2.5em;
  /* Adjust the font size as needed */
  font-weight: 700;
  color: #165ca9;
  margin-top: 10px;
  margin-bottom: 5px;
}
.signature_NZ2GR {
  margin-top: 10px;
  margin-bottom: 20px;
}
.custom_row_KBpJM {
  margin-bottom: 20px;
  /* Adjust the value as needed to increase the gap */
}
.page_b2tol {
  padding: 0 30px;
}
.breakhere_pO5K8 {
  page-break-after: always;
}
.p_n1AQS {
  font-family: Arial, Helvetica, sans-serif !important;
  font-size: 11pt !important;
  text-align: justify;
  margin-bottom: 5px;
}
.ul_GeAHp {
  font-family: Arial, Helvetica, sans-serif !important;
  font-size: 11pt !important;
}
.col_sm_JiB8U {
  width: 100%;
  margin-left: 5px;
  margin-right: 5px;
}
.signatureContainer_ZzJeM {
  display: flex;
  justify-content: flex-end;
  /* Align to the right */
}
.companyName_V9WqE {
  margin-top: 10px;
  margin-bottom: 10px;
}
.container_H2rgw {
  width: 100%;
}
.breakhere_pO5K8 {
  page-break-after: always;
}
.page-break-before__EcgU {
  page-break-before: always;
  border-bottom: 1px solid black;
}
/* Avoid breaking an element across pages */
.avoid-page-break_VoZ0B {
  border-bottom: 1px solid black;
  page-break-inside: avoid;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Clients/RegisteredClients/Individual/Buttons/Compliance/LetterofEngagement/custom.less"],"names":[],"mappings":"AAAA,eAAe;AACf;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ;AAEA;EACI,eAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAAJ;AAGA;EACI,cAAA;EACA,eAAA;EACA,WAAA;AADJ;AAIA;EACI,iBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAFJ;AAIA;EACI,gBAAA;EAFF,mCAAmC;EAGjC,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AADJ;AAGA;EACI,gBAAA;EACA,mBAAA;AADJ;AAIA;EACI,mBAAA;EAFF,mDAAmD;AACrD;AAGA;EACI,eAAA;AADJ;AAIA;EACI,wBAAA;AAFJ;AAIA;EACI,oDAAA;EACA,0BAAA;EACA,mBAAA;EACA,kBAAA;AAFJ;AAIA;EACI,oDAAA;EACA,0BAAA;AAFJ;AAIA;EACI,WAAA;EACA,gBAAA;EACA,iBAAA;AAFJ;AAKA;EACI,aAAA;EACA,yBAAA;EAHF,uBAAuB;AACzB;AAIA;EACI,gBAAA;EACA,mBAAA;AAFJ;AAKA;EACI,WAAA;AAHJ;AAKA;EACI,wBAAA;AAHJ;AAKA;EACI,yBAAA;EACA,8BAAA;AAHJ;AACA,2CAA2C;AAM3C;EACI,8BAAA;EACA,wBAAA;AAJJ","sourcesContent":["/* styles.css */\n.company_info {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.h4 {\n    margin-top: 5px;\n    margin-bottom: 15px;\n    font-size: 18px;\n    color: #165ca9;\n}\n\n.small {\n    display: block;\n    font-size: 12px;\n    color: gray;\n}\n\n.barcode {\n    margin-left: auto;\n    width: 150px;\n    height: 80px;\n    object-fit: contain;\n}\n.h3_span {\n    font-size: 2.5em; /* Adjust the font size as needed */\n    font-weight: 700;\n    color: #165ca9;\n    margin-top: 10px;\n    margin-bottom: 5px;\n}\n.signature {\n    margin-top: 10px;\n    margin-bottom: 20px;\n}\n\n.custom_row {\n    margin-bottom: 20px; /* Adjust the value as needed to increase the gap */\n}\n.page {\n    padding: 0 30px;\n}\n\n.breakhere {\n    page-break-after: always;\n}\n.p {\n    font-family: Arial, Helvetica, sans-serif !important;\n    font-size: 11pt !important;\n    text-align: justify;\n    margin-bottom: 5px;\n}\n.ul {\n    font-family: Arial, Helvetica, sans-serif !important;\n    font-size: 11pt !important;\n}\n.col_sm {\n    width: 100%;\n    margin-left: 5px;\n    margin-right: 5px;\n}\n\n.signatureContainer {\n    display: flex;\n    justify-content: flex-end; /* Align to the right */\n}\n.companyName {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.container {\n    width: 100%;\n}\n.breakhere {\n    page-break-after: always;\n}\n.page-break-before {\n    page-break-before: always;\n    border-bottom: 1px solid black;\n}\n\n/* Avoid breaking an element across pages */\n.avoid-page-break {\n    border-bottom: 1px solid black;\n    page-break-inside: avoid;\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"company_info": `company_info_TriNA`,
	"h4": `h4_RPaAb`,
	"small": `small_xuLpa`,
	"barcode": `barcode_vdXHI`,
	"h3_span": `h3_span_YBqm4`,
	"signature": `signature_NZ2GR`,
	"custom_row": `custom_row_KBpJM`,
	"page": `page_b2tol`,
	"breakhere": `breakhere_pO5K8`,
	"p": `p_n1AQS`,
	"ul": `ul_GeAHp`,
	"col_sm": `col_sm_JiB8U`,
	"signatureContainer": `signatureContainer_ZzJeM`,
	"companyName": `companyName_V9WqE`,
	"container": `container_H2rgw`,
	"page-break-before": `page-break-before__EcgU`,
	"avoid-page-break": `avoid-page-break_VoZ0B`
};
export default ___CSS_LOADER_EXPORT___;
